<template>
    <main>
        <!-- <topbar></topbar> -->
        <navbar active="2" @changeTab="changeTab"></navbar>

        <div class="container mgt_108">

            <div class="ask_form">
                
                <template v-if="$region=='jp'">
                    <div class="remind1" v-html="$t('service.replyProblems1')"></div>
                    <div class="remind1 remind2" v-html="$t('service.replyProblems2')"></div>
                </template>
                <template v-else>
                    <div class="remind">{{$t('service.replyProblems')}}！</div>
                </template>

                <div class="form_block">
                    <!-- <h5>帳號</h5> -->
                    <h5>{{$t('service.uname')}}</h5>
                    <input type="text" v-model="userInfo.nickName" readonly disabled="disabled">
                </div>

                <div class="form_block">
                    <h5>{{$t('service.game')}}</h5>
                    <k-select :selected="formData.game_base_id" :class="{err:errorInfo.game_base_id}"
                              :options="gameList" @selectedOption="selectGame"
                              :holderText="$t('service.choseGame')"></k-select>
                    <p v-text="errorInfo.game_base_id"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.questionsType')}}</h5>
                    <k-select :selected="formData.question_type" :class="{err:errorInfo.question_type}"
                              :options="typeList" @selectedOption="selectType"
                              :holderText="$t('service.choseRelevantQuestionType')"></k-select>
                    <p v-text="errorInfo.question_type"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.roleId')}}</h5>
                    <input type="text" :class="{err:errorInfo.character_id}" v-model="formData.character_id"
                           :placeholder="$t('service.writeRoleId')" @blur="vartify('character_id')">
                    <p v-text="errorInfo.character_id"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.roleName')}}</h5>
                    <input type="text" :class="{err:errorInfo.character_name}" v-model="formData.character_name"
                           :placeholder="$t('service.writeRoleName')" @blur="vartify('character_name')">
                    <p v-text="errorInfo.character_name"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.email')}}<span
                            class="warnning" v-if="$region !== 'jp'">*{{$t('service.writeEmailGetNews')}}</span></h5>
                    <input v-if="$region !== 'jp'" type="text" :class="{err:errorInfo.email}" v-model="formData.email"
                           :placeholder="$t('service.writeUseEmail')" @blur="vartify('email')">
                    <input v-if="$region === 'jp'" type="text" :class="{err:errorInfo.email}" v-model="formData.email"
                           :placeholder="$t('service.writeUseEmail')" @blur="vartify('email', 'no')">
                    <p v-text="errorInfo.email"></p>
                </div>

                <!-- <div class="form_block">
                    <h5>Line Notify</h5>
                    <input type="text" v-model="line_notify" readonly disabled="disabled">
                </div> -->

                <div class="form_block">
                    <h5>{{$t('service.questionsTitle')}}</h5>
                    <input type="text" :class="{err:errorInfo.question_title}" v-model="formData.question_title"
                           :placeholder="$t('service.writeQuestionType')" @blur="vartify('question_title')">
                    <p v-text="errorInfo.question_title"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.questionsContent')}}</h5>
                    <textarea :class="{err:errorInfo.question_content}" v-model="formData.question_content"
                              :placeholder="$t('service.writeQuestionContent')"
                              @blur="vartify('question_content')"></textarea>
                    <p v-text="errorInfo.question_content"></p>
                </div>

                <div class="form_block">
                    <h5>{{$t('service.choseRecord')}}</h5>
                    <div class="imgInput">
                        <div class="previewImg" v-for="(i,n) in formData.attachments" :key="n" @click="imgView(n)"
                             :style="{backgroundImage:'url('+i+')'}">
                            <!-- <img :src="i" alt=""> -->
                        </div>
                        <template v-for="i in [1,2,3]">
                            <div class="file_btn" v-if="i>formData.attachments.length" :key="i">
                                <div class="loadingImg" v-if="i-formData.attachments.length==1&&loadingFlag"></div>
                                <input type="file" name="file" @click="onInputClick($event)" @change="uploadChange" accept="image/*">
                            </div>
                        </template>
                    </div>
                    <div class="info">{{$t('service.attachmentHint')}}。</div>
                </div>

                <div class="submit_btn" :class="{disable: !sendable}" @click="submitForm"
                     ga-data="2301001">{{$t('service.sureSent')}}
                </div>

            </div>

        </div>

        <div class="imgPreview" :class="{out:!showImg}">

            <div class="backbar">
                <div class="back_btn" @click="showImg = false">
                    <img src="../images/back.svg" alt="">
                </div>
                <span class="tit">{{$t('service.lookRecord')}} </span>
                <span class="tit swiper-pg" slot="pagination"></span>

                <div class="del" @click="delImg">
                    <img src="../images/delete.svg" alt="">
                </div>
            </div>

            <swiper :options="swiperOption" ref="mySwiper">

                <!-- 这部分放你要渲染的那些内容 -->
                <swiper-slide v-for="(i,n) in formData.attachments" :key="n">
                    <div class="imgBox">
                        <img class="swp_img" :src="i" alt="">
                    </div>
                </swiper-slide>
            </swiper>
        </div>

        <goTop></goTop>
<h5-nav v-if="$region !== 'jp' "></h5-nav>
        <!-- <bottombar></bottombar> -->
        
    </main>
</template>

<script>
    // import topbar from '@/component/topbar_h5/index.vue';
    import navbar from './component/navbar';
    // import bottombar from '@/component/bottombar_h5/index.vue';
    import kSelect from './component/select';
    import goTop from './component/goTop';
import h5Nav from "@/component/h5nav/komoe";
    import { mapGetters } from "vuex";

    import {swiper, swiperSlide} from 'vue-awesome-swiper';

    export default {
        name: "index",
        data() {
            return {
                showImg: false,
                formData: {
                    game_base_id: "",
                    question_type: "",
                    character_id: "",
                    character_name: "",
                    email: "",
                    question_title: "",
                    question_content: "",
                    attachments: [],
                    source: "web"
                },
                gameList: [],
                typeList: [],
                errorInfo: {
                    game_base_id: "",
                    character_id: "",
                    character_name: "",
                    email: "",
                    question_type: "",
                    question_title: "",
                    question_content: "",
                },
                swiperOption: {
                    //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true  
                    notNextTick: true,
                    pagination: {
                        el: '.swiper-pg',
                        type: 'fraction'
                    },
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    paginationClickable: true,
                    spaceBetween: 30
                },
                sendable: true,
                loadingFlag: false
            };
        },
        components: {
            // topbar,
            goTop,
            // bottombar,
            navbar,
            kSelect,
            swiper,
            swiperSlide,
            h5Nav
        },
        watch: {
            formData: {
                handler: function(){
                    this.available();
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            selectGame(i) {
                this.formData.game_base_id = i.id;
                this.errorInfo.game_base_id = "";
            },
            selectType(i) {
                this.formData.question_type = i.id;
                this.errorInfo.question_type = "";
            },
            vartify(i, notice) {

                //notice == "no" 不显示报错信息

                // const contentMaxLength = this.globalLang === 'en' ? 2000 : 1000
                // const titleMinLenth = this.globalLang === 'en' ? 10 : 5
                // const titleMaxLenth = this.globalLang === 'en' ? 200 : 100
                // const characterNameMinLenth = this.globalLang === 'en' ? 1 : 1
                // const characterNameMaxLenth = this.globalLang === 'en' ? 40 : 20
                // const characterIdReg = this.globalLang === 'en' ? /^[A-Za-z\d]{10,40}$/ : /^[A-Za-z\d]{5,20}$/
                const contentMaxLength = 1000
                const titleMinLenth = 5
                const titleMaxLenth = 100
                const characterNameMinLenth = 1
                const characterNameMaxLenth = 20
                const characterIdReg = /^[A-Za-z\d]{5,20}$/

                let match = {
                    game_base_id: this.$t('service.choseGame'),
                    character_id: this.$t('service.require'),
                    character_name: this.$t('service.require'),
                    email: this.$t('service.require'),
                    question_type: this.$t('service.choseQuestionType'),
                    question_title: this.$t('service.require'),
                    question_content: this.$t('service.vaildQuestionContent')
                };

                if (!match[i]) {
                    return true;
                }

                if (i == "question_content") {
                    if (this.formData[i].length > contentMaxLength) {
                        this.errorInfo[i] = match[i];
                        return false;
                    } else {
                        this.errorInfo[i] = "";
                        return true;
                    }
                } else if (this.formData[i] == "") {
                    if (notice != "no") {
                        this.errorInfo[i] = match[i];
                    }
                    return false;
                } else {

                    if (i == "email") {
                        // let eReg = /^[A-Za-z0-9._%-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,4}$/;
                        // 换为更为宽松的校验规则
                        let eReg = /^[A-Z a-z 0-9_.-]+@{1}[A-Z a-z 0-9_.-]+\.{1}[A-Z a-z 0-9_.-]+/;
                        if (!eReg.test(this.formData[i]) || this.formData[i].length > 50) {
                            if (notice != "no") {
                                this.errorInfo.email = this.$t('service.writeValidEmail');
                            }
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            return true;
                        }
                    } else if (i == "question_title") {
                        let l = this.formData.question_title.length;
                        if (l < titleMinLenth || l > titleMaxLenth) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildQuestionTitle');
                            }
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            return true;
                        }
                    } else if (i == "character_id") {
                        // let l = this.formData.character_id.length
                        if (!characterIdReg.test(this.formData.character_id)) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildRoleId');
                            }
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            return true;
                        }
                    } else if (i == "character_name") {
                        let l = this.formData.character_name.length;
                        if (l < characterNameMinLenth || l > characterNameMaxLenth) {
                            if (notice != "no") {
                                this.errorInfo[i] = this.$t('service.vaildRoleName');
                            }
                            return false;
                        } else {
                            this.errorInfo[i] = "";
                            return true;
                        }
                    } else {
                        this.errorInfo[i] = "";
                        return true;
                    }
                }

            },
            onInputClick(e) {
                if (this.loadingFlag || this.formData.attachments.length === 3) {
                    e.preventDefault();
                    return;
                }
            },
            uploadChange(e) {
                let file = e.target.files[0];

                let data = new FormData();
                data.append('file', file);
                data.append('size', file.size);
                if (!file.type || (file.type && file.type.indexOf('image') < 0)) {
                    alert(this.$t('service.uploadRightFile'));
                    return;
                }
                if (file.size / 1024 / 1024 > 5) {
                    alert(this.$t('service.vaildRecordSize'));
                    return;
                }

                this.loadingFlag = true;
                this.$apis.service.upload({data: data, ct: this.$utils.token("joy_jct")})
                    .then((res) => {
                        this.loadingFlag = false;
                        if (res.data.code == 0) {
                            if (this.formData.attachments.length <= 2) {
                                this.formData.attachments.push(res.data.data);
                            }
                        } else if (res.data.code == -1) {
                            alert(this.$t('service.vaildRecordSize'));
                        } else {
                            alert(res.data.message || this.$t('service.uploadPicError'));
                        }
                    }).catch(() => {
                    this.loadingFlag = false;
                    alert(this.$t('service.networkRequestError'));
                });
            },
            available() {
                let ava = true;
                for (const key in this.formData) {
                    if (this.formData.hasOwnProperty(key) && key != "question_content") {
                        if (!(this.$region === 'jp' && key === 'email')) {
                            if (!this.vartify(key, "no")) {
                                ava = false;
                            }
                        }
                    }
                }
                this.sendable = ava;
                // return ava;
            },
            submitForm() {
                // 校验
                for (const key in this.formData) {
                    if (this.formData.hasOwnProperty(key)) {
                        if (!(this.$region === 'jp' && key === 'email')) {
                            if (!this.vartify(key)) {
                                // console.log(key)
                                return;
                            }
                        }
                    }
                }

                if (!this.sendable || this.loadingFlag) {
                    return;
                }
                this.sendable = false;

                // 提交表单
                this.$apis.service.newWordOrder(
                    "",
                    this.formData.game_base_id,
                    this.formData.character_id,
                    this.formData.character_name,
                    this.formData.email,
                    this.formData.question_type,
                    this.formData.question_title,
                    this.formData.question_content,
                    this.formData.source,
                    this.formData.attachments,
                    this.$utils.token("joy_jct")
                ).then((res) => {
                    this.sendable = true;
                    if (res.data.code == 0) {
                        this.formData = {
                            game_base_id: "",
                            character_id: "",
                            character_name: "",
                            email: this.formData.email,
                            question_type: "",
                            question_title: "",
                            question_content: "",
                            attachments: [],
                            source: this.formData.source
                        };
                        this.$router.push({'name': 'serviceH5OrderDetail', query: {id: res.data.data.work_order_id}});
                    } else {
                        // 	alert(JSON.stringify([this.formData.game_base_id,
                        // this.formData.character_id,
                        // this.formData.character_name,
                        // this.formData.email,
                        // this.formData.question_type,
                        // this.formData.question_title,
                        // this.formData.question_content,
                        // this.formData.source,
                        // this.formData.attachments]))
                        // 	alert(JSON.stringify(res.data))
                        alert(this.$t(`serviceCode.${res.data.code}`) || res.data.message || this.$t('service.submitFail'));
                    }
                }).catch(() => {
                    this.sendable = true;
                    alert(this.$t('service.requestError'));
                });

            },
            imgView(i) {
                this.showImg = true;
                this.swiper.slideTo(i, 0);
            },
            delImg() {
                // console.log(this.swiper.activeIndex)
                this.formData.attachments.splice(this.swiper.activeIndex, 1);
                if (this.formData.attachments.length == 0) {
                    this.showImg = false;
                }
            },
             // 切换导航栏
			changeTab(url) {
				this.$router.push({
						path: url
				});
			},
        },
        created: function () {
        },
        computed: {
            ...mapGetters(["userInfo"]),
            swiper() {
                return this.$refs.mySwiper.swiper;
            }
        },
        mounted: function () {
            // url中获取game_base_id参数
            this.formData.game_base_id = this.$route.query.game_base_id;
            // 判断用户设备
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                this.formData.source = "Android";
            } else if (isiOS) {
                this.formData.source = "iOS";
            } else {
                this.formData.source = "web";
            }

            // 获取游戏列表
            this.$apis.service.commonGameList().then((res) => {

                if (res.data.code == 0) {
                    // this.gameList = res.data.data

                    this.gameList = res.data.data.map((i) => {
                        return {
                            id: i.game_base_id,
                            val: i.game_name
                        };
                    });
                }
            });

            // 获取问题类型列表
            this.$apis.service.commonQuestionTypeList().then((res) => {

                if (res.data.code == 0) {
                    // this.typeList = res.data.data
                    this.typeList = res.data.data.map((i) => {
                        return {
                            id: i.question_type,
                            val: i.question_type_desc
                        };
                    });
                }
            });

            // 获取line_notify 状态
            // getLineStatus().then((res)=>{
            // 	if (res.data.code == 0) {
            // 		this.line_notify = "已绑定"
            // 	}else if(res.data.code == -1){
            // 		this.line_notify = "未绑定"
            // 	}else{
            // 		this.line_notify = "??"
            // 	}
            // },(err)=>{
            // 	// console.log(err)
            // })

            // 自动获取用户email
            var ct = this.$utils.token("joy_jct");
            this.$apis.service.getConnectInfo(ct).then((res) => {
                if (res.data.code == 0) {
                    this.formData.email = res.data.data.email || "";
                }
            });
        }
    };
</script>

<style lang="scss">
    @import "../../scss/common_h5.scss";
    @import '~swiper/dist/css/swiper.css';
</style>
<style lang="scss" scoped>
    .ask_form {
        .remind1{
            width: 100%;
            border-radius: 0.08rem;
            background: #eee;
            margin-bottom: 0.2rem;
            color: #50BBE5;
            font-size: 0.11rem;
            padding: 0.1rem;
            box-sizing: border-box;
            line-height: 0.18rem;
            &.remind2{
                color: #333;
            }
        }
        .form_block {
            margin-bottom: .2rem;

            h5 {
                font-size: .12rem;
                color: $cl_dark;
                font-weight: normal;
                margin: 0 0 .1rem;

                .warnning {
                    font-size: .1rem;
                    color: #FF5555;
                }
            }

            & > input {
                display: block;
                width: 100%;
                line-height: .16rem;
                height: .4rem;
                box-sizing: border-box;
                padding: .12rem .12rem;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                border-radius: .2rem;
                font-size: .12rem;
                color: $cl_dark;
                box-shadow: none;
                outline: none;
                -webkit-tap-highlight-color: transparent;
                -webkit-appearance: none;

                &[readonly] {
                    background: #EEEEEE;
                    color: #999999;
                }

                &.err {
                    border: 1px solid #FF5555;
                }
            }

            textarea {
                display: block;
                width: 100%;
                padding: .12rem;
                box-sizing: border-box;
                line-height: .16rem;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                border-radius: .2rem;
                font-size: .12rem;
                color: $cl_dark;
                height: 1.2rem;
                resize: none;
                box-shadow: none;
                outline: none;
                -webkit-tap-highlight-color: transparent;
                -webkit-appearance: none;

                &.err {
                    border: 1px solid #FF5555;
                }
            }

            ::-webkit-input-placeholder {
                color: #CCCCCC;
            }

            :focus {
                border: 1px solid #50BBE5;
            }

            p {
                position: relative;
                top: .04rem;
                max-height: .08rem;
                margin: 0;
                font-size: .1rem;
                color: #FF5555;
                text-align: center;
            }

            .info {
                font-size: .1rem;
                color: #CCCCCC;
                line-height: .14rem;
                margin-top: .1rem;
            }

            .imgInput {
                display: flex;
                justify-content: space-between;

                .previewImg {
                    position: relative;
                    flex-shrink: 0;
                    flex-grow: 0;
                    height: 1rem;
                    width: 1rem;
                    overflow: hidden;
                    border-radius: .2rem;
                    background: #999999;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center center;

                    img {
                        display: block;
                        width: 100%;
                    }
                }

                .file_btn {
                    position: relative;
                    flex-shrink: 0;
                    flex-grow: 0;
                    height: 1rem;
                    width: 1rem;
                    overflow: hidden;
                    background: url(../images/addpic.svg) center center no-repeat;
                    background-size: contain;

                    input {
                        display: block;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }

                    .loadingImg {
                        position: absolute;
                        width: 1rem;
                        height: 1rem;
                        top: 0;
                        left: 0;
                        border-radius: 50%;
                        background: #ffffff url(../images/loading_small.svg) center center no-repeat;
                        background-size: .3rem .3rem;
                        animation: roll 1s infinite;
                    }
                }

            }
        }

        .submit_btn {
            background: #50BBE5;
            border-radius: .2rem;
            height: .4rem;
            line-height: .4rem;
            font-size: .14rem;
            color: #FFFFFF;
            text-align: center;
            margin-top: .3rem;
            cursor: pointer;

            &.disable {
                background: #CCCCCC;
            }
        }
    }

    .imgPreview {
        position: fixed;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: #000000;
        transition: all .2s;

        &.out {
            top: 100vh;
            opacity: 0;
        }

        .imgBox {
            position: relative;
            width: 100vw;
            height: calc(100vh - .48rem);

            .swp_img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 100vw;
                max-height: 100vh;
                width: auto;
                height: auto;
            }

        }

    }

    .backbar {
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100%;
        padding: .14rem .12rem;
        line-height: .2rem;
        height: .48rem;
        background: $cl_green;
        font-size: 0;
        box-sizing: border-box;

        .tit {
            color: #fff;
            font-size: .12rem;
            vertical-align: middle;
        }

        .back_btn {
            display: inline-block;
            vertical-align: middle;
            margin-right: .12rem;

            img {
                width: .2rem;
                display: block;
            }
        }

        .del {
            float: right;
            width: .2rem;
            height: .2rem;

            img {
                display: block;
            }
        }
    }

    @keyframes roll {
        from {
            transform: rotateZ(0)
        }
        to {
            transform: rotateZ(360deg)
        }
    }
</style>
